// src/components/Home/Home.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

import HomeAbout from './HomeAbout/HomeAbout';
import Experience from './Experience/Experience';
import Education from './Education/Education';
import SvgContainer from '../SvgContainer/SvgContainer';
import SvgContainer1 from '../SvgContainer/SvgContainer1';

import './Home.css';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Srihari Muppalla | Full Stack Developer & Web Developer & Email Developer in Bangalore</title>
        <meta
          name="description"
          content="Srihari Muppalla, a skilled Full Stack Developer, Web Developer, and Email Developer in Bangalore, India. Specializing in responsive websites, email campaigns, and user-centric solutions."
        />
        <meta
          name="keywords"
          content="Srihari Muppalla, Full Stack Developer, Web Developer, Email Developer, Bangalore, India, responsive websites, email campaigns, React.js, Node.js, Express.js, Next.js, HTML, CSS, JavaScript and AMP Script"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Srihari Muppalla" />
        <link rel="canonical" href="https://sriharim.in/" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Srihari Muppalla | Full Stack Developer & Web Developer & Email Developer in Bangalore"
        />
        <meta
          property="og:description"
          content="Srihari Muppalla, a skilled Full Stack Developer, Web Developer, and Email Developer in Bangalore, India. Specializing in responsive websites, email campaigns, and user-centric solutions."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sriharim.in/" />
        <meta property="og:image" content="https://sriharim.in/Logo.png" /> {/* Replace with your image */}
        <meta property="og:image:alt" content="Srihari Muppalla - Full Stack Developer" />
        <meta property="og:site_name" content="Srihari Muppalla Portfolio" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Srihari Muppalla | Full Stack Developer & Web Developer & Email Developer in Bangalore"
        />
        <meta
          name="twitter:description"
          content="Srihari Muppalla, a skilled Full Stack Developer, Web Developer, and Email Developer in Bangalore, India. Specializing in responsive websites, email campaigns, and user-centric solutions."
        />
        <meta name="twitter:image" content="https://sriharim.in/Logo.png" /> {/* Replace with your image */}
        <meta name="twitter:image:alt" content="Srihari Muppalla - Full Stack Developer" />
        <meta name="twitter:creator" content="@srihariM64" /> {/* Replace with your Twitter handle */}
      </Helmet>
      <div className="home-container">
        <HomeAbout />
        <SvgContainer />
        <Experience />
        <SvgContainer1 />
        <Education />
      </div>
    </>
  );
};

export default Home;